import {
  alertSuccess,
  AsyncButton,
  ButtonStyle,
  Card,
  CardContent,
  CardHeader,
  CardSize,
  ColorField,
  InputGroup,
  removeHash,
} from '@one-tree/library'
import React, { ReactElement } from 'react'
import { Prompt } from 'react-router-dom'
import { useOrganisation } from '../../../context/OrganisationProvider'
import { patchOrganisation } from '../../../helpers/APIHelper'
import { useDraft } from '../../../hooks/useDraft'
import AnnouncementBarNote from './AnnouncementBarNote'
import ItemPreview from '../../webShop/ItemPreview'
import { GridWithPreview, Header, Section } from '../../webShop/WebShopHelper'
import { Org, UpdateOrg } from './PromotionHelper'

export default function PromotionSettings(): ReactElement {
  const { organisation, saveOrganisation } = useOrganisation()
  const { values, changes, handleChange, hasChanges, reset } = useDraft<
    Org,
    UpdateOrg
  >(organisation ?? undefined)

  if (!organisation || !('id' in values)) return <div>No organisation found</div>

  const savePromotionSettings = async (): Promise<void> => {
    if (organisation && hasChanges) {
      const res = await patchOrganisation({
        organisationId: organisation.id,
        patchOptions: changes,
      })
      if (res) {
        saveOrganisation(res)
        reset()
        alertSuccess('Promotion settings saved')
      }
    }
  }

  return (
    <>
      {hasChanges && (
        <Prompt
          message={(): string => 'You have unsaved changes, are you sure you want to leave?'}
        />
      )}
      <Card cardSize={CardSize.Big}>
        <CardHeader title="Customise promotions">
          <AsyncButton
            buttonStyle={ButtonStyle.Action}
            disabled={!hasChanges}
            onClick={savePromotionSettings}
          >
            Save
          </AsyncButton>
        </CardHeader>
        <CardContent>
          <GridWithPreview>
            <div>
              <Section>
                <Header>
                  <h3>Callout colours</h3>
                </Header>
                <InputGroup>
                  <ColorField
                    label="Background"
                    onChange={(value): void => handleChange('colourCalloutBackground', removeHash(value))}
                    value={values.colourCalloutBackground || ''}
                  />
                  <ColorField
                    label="Highlight"
                    onChange={(value): void => handleChange('colourCalloutHighlight', removeHash(value))}
                    value={values.colourCalloutHighlight || ''}
                  />
                </InputGroup>
              </Section>
              <AnnouncementBarNote />
            </div>
            <ItemPreview values={values} withPromo={true} />
          </GridWithPreview>
        </CardContent>
      </Card>
    </>
  )
}
